import dynamic from "next/dynamic";
import { PropertyListProps } from ".";
import React from "react";
import {
    Divider,
    Skeleton
} from 'antd';
import {
    BreadcrumbBar,
} from '../'
import styles from './autoseocontent.module.scss';
import { SubcateLinks } from "../SubcateLinks";
import { ProvinceLinks } from "../ProvinceLinks";

const DynamicSearchByOptions = dynamic<any>(() => import('../')
  .then(module => module.SearchByOptions), {
    ssr: false,
  })

const DynamicLeaveYourRequirement = dynamic<any>(() => import('../../components/')
  .then(module => module.LeaveYourRequirement), {
    ssr: false,
  })

const DynamicAdBannerVertical = dynamic<any>(() => import('../')
  .then(module => module.AdBannerVertical), {
    ssr: false,
  }) 


const DynamicListSection = dynamic<any>(() => import('./listSection')
  .then(module => module.ListSection), {
    ssr: false,
  })
const DynamicLinkRecommended = dynamic<any>(() => import('../../components/')
    .then(module => module.LinkRecommended), {
      ssr: false,
    })
  
// const DynamicLinkHits = dynamic(() => import('../../components')
//     .then(module => module.LinkHits), { ssr: false })
  
    
export const PropertyListSection = (props: PropertyListProps) => {

    const { 
        breadcrumb, 
        locale, 
        t, 
        data,
        h1Text,
        h2Text,
        action,
        type,
        handleOnCategoryChanged,
        handlePageChange,
        handleCardOnClick,
        handleOnMouseDown,
        isMobileFilterOpen,
        onMobileSearchOk,
        onMobileSearchClose,
        provinceTable,
        actionsTable,
        categoryTable,
        showListPathIds,
        locationTypeTable,
        seocontent,
        actionCateLocationType,
        loading,
        recommendList,
        category,
        hasrecommendList,
        endList,
        categoryid, actionid,
        searchParamsList 
    } = props;

    const newUI = () => {
        console.log('newUI data: ', data)
        return (
            <div className={styles.listsectionContainer}>
                <div className={styles.list}>
                    <DynamicListSection {...props} /> 
                </div>
                <div className={styles.leaveYourReq} >
                    <DynamicLeaveYourRequirement t={t}/>
                    {
                       loading ? <Skeleton active />
                       : <SubcateLinks t={t} actionid={actionid} categoryid={categoryid} locale={locale} 
                          showListPathIds={showListPathIds}
                          searchParamsList={searchParamsList}
                          actionsList={actionsTable}
                          categoryList={categoryTable}
                        />
                    } 
                    {
                        loading ? <Skeleton active />
                        : recommendList !== null && hasrecommendList > 0 
                        && <DynamicLinkRecommended t={t} recommendList={recommendList} action={action} category={category} locale={locale} />
                    } 
                    {
                        loading ? <Skeleton active />
                        : <ProvinceLinks searchParamsList={searchParamsList}
                          locale={locale} t={t} category={category} action={action}
                          />
                    }
                    <DynamicAdBannerVertical adSlot={'9031826647'} 
                        style={{width: '100%', paddingTop: '10px'}}
                    />
                </div>
            </div>
        )
    }
    
    return (
        <div style={{display: 'flex', flexDirection: 'column'}}>
            {
              !loading? 
               <DynamicSearchByOptions nologo 
                searchbgClass={{width: "100%" }}
                isMobileFilterOpen={isMobileFilterOpen} 
                onMobileSearchOk={onMobileSearchOk}
                onMobileSearchClose={onMobileSearchClose}
                provinceTable = {provinceTable}
                locationTypeTable={locationTypeTable}
                    actionsTable ={actionsTable}
                    categoryTable ={categoryTable}
                pathIds = { showListPathIds }
                actionCateLocationType = {actionCateLocationType}
                loading={loading}
                />
                : undefined
            }
            <Divider/>
            <BreadcrumbBar breadcrumb={breadcrumb} locale={locale} t={t} />
            {
                !loading? newUI(): undefined
            }
        </div>
    )
};